import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import GridDateFormatter from '../../../GridDateFormatter';
import { connect } from 'react-redux';
import { fetchMembershipUsersByUser } from '../../../../../Redux/Actions/Admin/ManageMembershipUserActions';
import { toastr } from '../../../../../Redux/Actions/CommonActions';
import { Switch } from '@progress/kendo-react-inputs';
import { Alert } from 'reactstrap';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import cellWithReading from './CellWithReading';
import MembershipUserForm from './MembershipUserForm';
import Search from '../../../Search';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import './ManageMembershipUser.scss';
import Modal from 'react-modal';
import '../ManageUsers/ManageUser.scss';
import MembershipUserLoader from './MembershipUserLoader'
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';
import DialogContainer from './Dialogs/DialogContainer';

const FileDownload = require('js-file-download');

class MangeMembershipUsers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSubmitted: false,
            membershipUserInEdit: {},
            isPopupVisible: false,
            membershipUsers: { data: [], total: 0 },
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "CreateDate", dir: "desc" }],               
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""
        };
    }

    dataStateChange = (e) => {

        if (e.data && e.data.filter && e.data.filter.filters) {
            var filters = e.data.filter.filters;

            for (var i = 0; i < filters.length; i++) {
                if (filters[i].field && filters[i].field == "CreateDate") {
                    var operator = filters[i].operator;

                    if ((operator == "gt" || operator == "gte") && !filters[i].value) {

                        filters[i].value = new Date('January 01, 1900');

                    } else if ((operator == "lt" || operator == "lte") && !filters[i].value) {

                        var currentDatetime = new Date();

                        filters[i].value = new Date(Date.UTC(currentDatetime.getFullYear(), currentDatetime.getMonth(), currentDatetime.getDate()));

                    }
                } else if (filters[i].value == null) {
                    filters[i].value = "";
                }
            }
        }

        this.setState({
            ...this.state,
            dataState: e.data
        });
    }

    dataRecieved = (membershipUsersFetched) => {
        //debugger;
        this.setState({
            ...this.state,
            membershipUsers: membershipUsersFetched,
            isLoading: false
        });

        if (membershipUsersFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
            let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
        }
        else if (membershipUsersFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
            document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
        }
    }

    read = (dataItem) => {
        this.setState({
            membershipUserInEdit: Object.assign({}, dataItem),
            membershipUserId: dataItem.PortalUserID,
            membershipAssignmentId: dataItem.MembershipAssignmentIds || 0,
            isPopupVisible: true
        })
    };

    cancel = () => {
        this.setState({ isPopupVisible: false })
    };

    stringifyObj = (arr) => {
        let t = [...arr];
        if (!t) {
            return null;
        }
        else {
            for (var i = 0; i < t.length; i++) {
                var element = { ...t[i] };
                for (var key in t[i]) {
                    element[key] = element[key] + '';
                }
                t[i] = element;
            }
            return t;
        }
    }

    exportToExcel = () => {
        var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
        var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
        var KendoGridQuery = {
            Filters: Filters ? Filters.slice() : [],
            Sorts: Sorts ? Sorts.slice() : []
        }

        axios.get(ROOT_API_URL + "/ManageMembershipUsers/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
            .then((response) => {
                FileDownload(response.data, 'Users.csv');
            }).catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to export to excel.';

                this.setState({
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            });
    }

    save = (model) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "CreateDate", dir: "desc" }]
            },
        });

        // reassign State model.
        var stateObj = {};
        stateObj.Id = Number(model.StateId);
        stateObj.Name = model.State;
        model.State = stateObj;

        // reassign MembershipPackage.
        // var membershipPackageObj = {};
        // membershipPackageObj.MembershipPackageID = Number(model.MembershipPackageID);
        // membershipPackageObj.MembershipPackage = model.MembershipPackage;
        // membershipPackageObj.Cost = Number(model.Cost);
        // membershipPackageObj.MembershipTypeID = Number(model.MembershipTypeID);
        // membershipPackageObj.AdditionalMemberships = Number(model.AdditionalMemberships);
        // model.MembershipPackage = membershipPackageObj;
        model.MembershipPackage = null;

        // reassign MembershipType;
        // var membershipTypeObj = {};
        // membershipTypeObj.MembershipTypeID = Number(model.MembershipTypeID);
        // membershipTypeObj.MembershipType = model.MembershipType;
        // model.MembershipType = membershipTypeObj;
        model.MembershipType = null;

        var url = `${ROOT_API_URL}/ManageMembershipUsers/UpdateMembershipUser`;
        const options = { method: 'POST', headers: auth.authHeader() };

        axios
            .post(url, model, options)
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to save the user.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            });
    }

    toggleActive = (dataItem) => {
        dataItem.IsActive = !dataItem.IsActive;
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "IsActive", operator: "eq", value: true }]
                },
                sort: [{ field: "CreateDate", dir: "desc" }],
            },
        });
        //var model = {
        //    MembershipAssignmentId: dataItem.MembershipAssignmentId
        //};
        var stateObj = {};
        stateObj.Id = Number(dataItem.StateId);
        stateObj.Name = dataItem.State;
        dataItem.State = stateObj;

        if (!dataItem.PortalUserID) {
            this.setState({
                isSubmitted: false,
                alertVisible: true,
                alertColor: "danger",
                alertMessage: 'Unable to deactivate User, User ID not found.'
            });

            setTimeout(() => {
                this.setState({
                    alertVisible: false,
                    alertMessage: ''
                });
            }, 5000);

        }
        axios
            .post(`${ROOT_API_URL}/ManageMembershipUsers/ToggleActiveMembershipUser`, dataItem, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to deactivate the user.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            });
    }


    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }

    render() {
        return (
            <div id={"memberships-users-grid"}>
                <AdminHeader />
                {this.state.isLoading ?
                    (<div>
                        <IsLoading message="Loading users" />
                    </div>

                    ) :
                    (
                        <div>
                            <Alert
                                color={this.state.alertColor}
                                isOpen={this.state.alertVisible}
                                toggle={() => {
                                    this.setState({ alertVisible: false, alertMessage: "" })
                                }}
                            >
                                {this.state.alertMessage}
                            </Alert>
                            <Grid
                                style={{ width: '80vw', height: '80vh' }}
                                filterable={true}
                                sortable={true}
                                pageable={true}
                                total={this.state.membershipUsers.total}
                                {...this.state.dataState}
                                {...this.state.membershipUsers}
                                onDataStateChange={this.dataStateChange}
                                resizable
                                reorderable={true}
                            >
                                <GridToolbar>
                                    {/*<div className="admin-grid-toolbar-box1">
                                        <Search customFunc={this.filterSize} />
                                        <Switch
                                            // style="width:70px"
                                            filter="boolean"
                                            onChange={this.handleChange}
                                            onLabel={'Active'}
                                            offLabel={'InActive'}
                                            checked={this.state.toggled}
                                        />
                                    </div>*/}

                                    <div className="admin-grid-toolbar-box2">
                                        <a id="excel-ref" href={ROOT_API_URL + "/ManageMembershipUsers/ExportToExcel"} display="none" download></a>
                                        <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                                            <i className="fas fa-file-export"></i>
                                            EXPORT TO EXCEL
                                        </button>
                                    </div>
                                </GridToolbar>

                                <Column filterable={false} width="100px" cell={cellWithReading(this.read, this.toggleActive)} />
                                {/*<Column field="ParsedMembershipId" title="Membership ID" filter="text" />
                                <Column field="CreateDate" title="Created Date" filter="date" cell={GridDateFormatter} />*/}
                                <Column field="FirstName" title="First Name" filter="text" />
                                <Column field="LastName" title="Last Name" filter="text" />
                                <Column field="Email" title="Email" filter="text" />
                                {/*<Column field="InvitationType" title="User Type" filter="text" />*/}
                                <Column field="Address1" title="Address 1" filter="text" />
                                <Column field="Address2" title="Address 2" filter="text" />
                                <Column field="State" title="State" filter="text" />
                                <Column field="City" title="City" filter="text" />
                                {/*<Column field="County" title="County" filter="text" />*/}
                                <Column field="Zip" title="Zip" filter="text" />
                                <Column field="Phone" title="Phone" filter="text" />
                                {/*<Column field="MembershipType" title="Membership Type" filter="text" />*/}
                                {/*<Column field="MembershipPackage" title="Membership Package" filter="text" />*/}
                                {/*<Column field="OrganizationName" title="Membership Name" filter="text" />*/}
                                <Column field="IsActive" title="Is Active" filter="boolean" />
                                <Column field="IsLockedOut" title="Locked" filter="boolean" />
                            </Grid>
                        </div>
                    )
                }
                <div>
                    {!this.state.isSubmitted ?
                        <MembershipUserLoader
                            dataState={this.state.dataState}
                            onDataRecieved={this.dataRecieved}
                        />
                        : ""
                    }
                </div>
                {<div>
                    <Modal
                        isOpen={this.state.isPopupVisible}
                        onRequestClose={this.cancel}
                        contentLabel="Example Modal"
                        ariaHideApp={false}
                        style={{
                            content: {
                                top: '50%',
                                left: '50%',
                                right: 'auto',
                                bottom: 'auto',
                                marginRight: '-50%',
                                minWidth: '80vw',
                                maxWidth: '80vw',
                                minHeight: '80vh',
                                maxHeight: '80vh',
                                overflow: 'auto',
                                transform: 'translate(-50%, -50%)',
                                borderRadius: '5px'
                            }
                        }}
                    >
                        <DialogContainer
                            dataItem={this.state.membershipUserInEdit}
                            save={this.save}
                            cancel={this.cancel}
                            userId={this.state.membershipUserId}
                            membershipAssignmentId={this.state.membershipAssignmentId}
                            //saveAdminMembership={this.props.saveMembership}
                        />
                    </Modal>
                </div>}
            </div>

        );
    }
}

function mapStateToProps(state) {
	return {
		membershipUsersDetails: state.membershipUser.membershipUsersDetails,
		common: state.common
	};
}

export default connect(mapStateToProps, {
	fetchMembershipUsersByUser,
	toastr
})(MangeMembershipUsers);
